import GridItem from "../../../../Components//UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useLocation } from 'react-router-dom';
import RegionRegistrationForm from "./RegionRegistrationForm";
import { useTranslation } from 'react-i18next';

// Main component for creating/registering a new agency/region
const CreateRegion = () => {
  const { t } = useTranslation();

  const location = useLocation();

  // Layout configuration for the grid system
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader title={t('createregion_management_formheader')}
          showIconsForback={true} />
      ),
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 11,
      id: 2,
      component: <RegionRegistrationForm parentAgencyId={location.state.parentAgencyId} />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default CreateRegion;